import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutVoidChecks extends Layout {
    buttonCancel: Button;
    buttonVoid: Button;
    labelVoidChecks: Label;
    sourceDrsCheck: DataSource;
    tableVoidChecks: Table;
}
